import React, { useState } from "react";
import QrScanner from "./QrScanner";
import { message } from "antd";
import QrDisplay from "./QrDisplay";
import TransferForm from "./TransferForm";
import SendMoneySuccess from "../Payments/SendMoneySuccess";

const PaymentFlow = ({
  setView,
  userDetails,
  walletDetails,
  settingDetails,
  customerType,
  setParentTab,
}) => {
  const [scannerOpen, setScannerOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("home");
  const [formData, setFormData] = useState({
    payee: null,
    description: "",
    category: "",
    amount: "",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleScanSuccess = (data) => {
    try {
      const parsed = JSON.parse(data);

      console.log("parsed", parsed);

      setFormData((prev) => ({
        ...prev,
        payee: {
          accountNumber: parsed.accountNumber,
          walletId: parsed.walletId,
          mobileNo: parsed.mobileNo,
        },
        amount: parsed.amount ? parsed.amount : prev.amount,
      }));

      setScannerOpen(false); // close scanner
      setActiveTab("transfer"); // open transfer screen
    } catch (e) {
      message.error("Invalid QR Code");
    }
  };

  return (
    <>
      {!scannerOpen && activeTab !== "transfer" && (
        <QrDisplay
          setView={() => setScannerOpen(true)}
          walletDetails={walletDetails}
          userDetails={userDetails}
        />
      )}
      {scannerOpen && (
        <QrScanner
          onClose={() => setScannerOpen(false)}
          onScanSuccess={handleScanSuccess}
        />
      )}

      {activeTab === "transfer" && (
        <TransferForm
          formData={formData}
          handleChange={handleChange}
          setActiveTab={setActiveTab}
          userDetails={userDetails}
          walletDetails={walletDetails}
          settingDetails={settingDetails}
          customerType={customerType}
        />
      )}

      {activeTab === "sendMoneySuccess" && (
        <SendMoneySuccess
          onHome={() => setParentTab("home")}
          onViewTransaction={(e) => setParentTab(e)}
        />
      )}
    </>
  );
};

export default PaymentFlow;
